import { render, staticRenderFns } from "./SubTitleQa.vue?vue&type=template&id=4477f6db&scoped=true"
import script from "./SubTitleQa.vue?vue&type=script&lang=js"
export * from "./SubTitleQa.vue?vue&type=script&lang=js"
import style0 from "./SubTitleQa.vue?vue&type=style&index=0&id=4477f6db&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4477f6db",
  null
  
)

export default component.exports